module.exports = __webpack_public_path__ + "static/img/pilates-tile-test.7deba40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pilates-tile-test.jpg
// module id = kNBj
// module chunks = 1